// extracted by mini-css-extract-plugin
module.exports = {"module":"Submenu_module__2DmHD","submenuInner":"Submenu_submenuInner__3iDhu","divider":"Submenu_divider__1UPc3","spaceEvenly":"Submenu_spaceEvenly__25rze"};